import React, {useState, useEffect} from "react";
import {useDispatch} from "react-redux";
import Request from "../../components/api/Request";
import {Button} from "devextreme-react/button";
import TextBox from "devextreme-react/text-box";
import {CheckBox} from 'devextreme-react/check-box';
import {Popup} from 'devextreme-react/popup';
import TesvikSgkLogin from "./TesvikSgkLogin";
import * as AppActions from '../../actions/AppActions';

const BildirgeLoginIslemleri = (props) => {
    const dispatch = useDispatch();

    const popupBasligi = "Login Bilgileri";


    let donem = props.data.donemAdiList.join(" - ");
    const [dataInfo, setDataInfo] = useState({
        donemAdi: "",
        domainId: props.data.domainId,
        domainAdi: props.data.domainAdi,
        donemIdList: props.data.donemIdList,
        donemAdiList: props.data.donemAdiList,
        donem: donem,
        onayliIndir: false,
        bildirgeSistemiLogin: false
    });

    const [loginData, setLoginData] = useState({popupState: false, data: {}});


    useEffect(() => {
        setButtonState();

    }, []);

    function setButtonState() {

        dispatch(AppActions.setLoading(true, "Bildirge servisi login bilgileri alınıyor.."));
        const request = new Request("/bildirgeIslemleri/isLogin/" + props.data.domainId, "GET");
        request.run()
            .then(response => {
                if (response.data.success == true) {
                    setDataInfo(Object.assign({}, dataInfo, {
                        bildirgeSistemiLogin: response.data.data
                    }));


                        if (response.data.data.bildirge) {
                            dispatch(AppActions.setLoading(false, ""));
                            props.hide();
                        }

                }
                dispatch(AppActions.setLoading(false, ""));

            })
            .catch(() => {
                dispatch(AppActions.setLoading(false, ""));
            });
    }

    function hideBildirgeIslemleriPopup() {
        setLoginData({popupState: false, data: {}})
        setButtonState();
    }

    function showBildirgeLoginPopup() {
        setLoginData({
            popupState: true,
            data: {domainId: props.data.domainId, sistem: "bildirge"}
        });
    }


    function donemIslemBaslat() {

            donemIndir(dataInfo.domainId, dataInfo.donemIdList, dataInfo.donemAdiList, 0);


    }

    function donemIndir(domainId, donemIdList, donemAdiList, index) {
        //debugger;
        //dataInfo.onayliIndir = !dataInfo.onayliIndir;
        if (donemIdList.length > index) {
            let donemId = donemIdList[index];
            let donemAdi = donemAdiList[index];

            let mesaj = "(" + (index + 1) + "/" + donemIdList.length + ")  " + donemAdi + " Dönemi indiriliyor ";

            dispatch(AppActions.setLoading(true, mesaj));

            const request = new Request("/bildirgeIslemleri/donemIndir/" + dataInfo.domainId + "/" + donemId, "GET");
            request.run().then((response) => {
                //debugger;
                dispatch(AppActions.setLoading(false, ""));
                if (response && response.data && response.data.data === true) {
                    index++;
                    donemIndir(domainId, donemIdList, donemAdiList, index);
                }
            }).catch((error) => {
                dispatch(AppActions.setLoading(false, ""));
            });
            ;
        } else {
            props.hide();
        }
    }

  function muhtasarIslemBaslat() {

      let mesaj = "Muhtasar Indiriliyor... ";

      dispatch(AppActions.setLoading(true, mesaj));

      const request = new Request("/bildirgeIslemleri/donemIndirMuhtasarOnayBekleyen/" + dataInfo.domainId , "GET");
      request.run().then((response) => {
        //debugger;
        dispatch(AppActions.setLoading(false, ""));
        if (response && response.data && response.data.data === true) {
            props.hide();
        }
      }).catch((error) => {
        dispatch(AppActions.setLoading(false, ""));
      });
      ;
  }

    return (
        <React.Fragment>

            <TextBox readOnly={true} hoverStateEnabled={false} value={dataInfo.domainAdi}
                    />
            <br></br>
            <TextBox readOnly={true} hoverStateEnabled={false} value={dataInfo.donem}
                    />
            <br></br>

            <Button width={300} text="Bildirge Sistemi Giriş" type="danger" stylingMode="contained"
                    visible={!dataInfo.bildirgeSistemiLogin}
                    onClick={showBildirgeLoginPopup}
            />
          <Button
              width={300}
              text={ "Dönem İndir" }
              type="success"
              stylingMode="contained"
              visible={ dataInfo.bildirgeSistemiLogin }
              onClick={donemIslemBaslat}
          />

            <br></br>
            <Button
                width={300}
                text={"Muhtasar indir" }
                type="success"
                stylingMode="contained"
                visible={ dataInfo.bildirgeSistemiLogin }
                onClick={muhtasarIslemBaslat}
            />



            <Popup
                visible={loginData.popupState}
                onHiding={hideBildirgeIslemleriPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={true}
                title="Sgk Login işlemleri"
                width={300}
                height={200}
            >
                <div>
                    {loginData.popupState ?
                        <TesvikSgkLogin data={loginData.data} hide={hideBildirgeIslemleriPopup}/> : null}
                </div>
            </Popup>

        </React.Fragment>
    );
};

export default BildirgeLoginIslemleri;

